var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style[_vm.variant]]},[_c('span',[_vm._v(_vm._s(_vm.resource.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }